export default __webpack_public_path__ + "static/media/num-02.0e1a8689.svg";